import { useReducer } from 'react';
import { defaultContextValues, IState, NewRoleStateContext, NewRoleDispatchContext } from './useNewRoleContext';
import { IAction, newRoleReducer } from './newRoleReducer';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface INewRoleProviderProps {
  children: any;
  value?: IValue;
}

export function NewRoleProvider({
  children,
  value = { initialState: defaultContextValues, reducer: newRoleReducer },
}: INewRoleProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <NewRoleStateContext.Provider value={state}>
      <NewRoleDispatchContext.Provider value={dispatch}>{children}</NewRoleDispatchContext.Provider>
    </NewRoleStateContext.Provider>
  );
}
